import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowMainItemPublisher, canShowMainItemTitle } from 'shared/selectors/app-settings';

import OverlayStripBase from './strip-base';

import styles from './strip.styl';


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayStrip extends OverlayStripBase {

  static displayName = 'OverlayStrip';

  static propTypes = {
    buttonsWrapperClassName: React.PropTypes.string,
  };

  get buttons() {
    const { videoItem, buttonsWrapperClassName } = this.props;

    if (!videoItem) {
      return null;
    }

    return (
      <div styleName="buttons-wrapper"
           className={buttonsWrapperClassName}>
        {this.playButton}
        {this.subscribeButton || this.purchaseButton}
        {this.playNextButton}
      </div>
    );
  }

  render() {
    const { channelData, className } = this.props;

    if (!channelData) {
      return null;
    }

    const styles = this.getOpacityStyles();

    return (
      <div style={styles}
           styleName="overlay"
           className={className}
           onClick={this.playSelectedVideo}>
        <div styleName="content">
          <div styleName="top-content"
               className="qa-player-overlay">
            {this.publisher}
            {this.title}
            {this.buttons}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/strip/strip.js